import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import about from './About.module.css';
import { Link } from 'react-router-dom';


function About() {
    return (
        <Container fluid>
            <Row>
                <Col>
                    <div className={about.container}>
                        <figure>
                            <img id={about.lydiaphoto} src="img/profilephoto.jpg" alt="Lydia"></img>
                        </figure>                    
                        <div className="centre">                        
                            <h2 className="white">
                                <span>ABOUT</span>
                            </h2>
                        </div>
                    </div>
                </Col>               
            </Row>
            <Row>
                <Col>
                    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 20px' }}>
                        <div id={about.biotitle}>
                            <h5>About Me</h5>
                        </div>
                        <div>
                            <a href="https://www.conservationregister.com/acr-profile-page/2134/"><img id={about.iconimg} src="/img/ICON-accredited-member.jpg" alt="Accredited Member"></img></a>
                        </div>
                        <div>
                            <p className="centrep">
                                Welcome to my page. My name is Lydia Messerschmidt — I am a conservator drawn to the beauty, fragility, and complexity of organic materials. From the first time I worked with feathers, I was captivated by their structure, their extraordinary diversity of use, and the unique challenges they present. That early fascination grew into a specialist practice centred on feather conservation and the intricate world of historic folding fans.
                                </p>
                            <p className="centrep">
                                My work in this field is driven by a deep respect for craftsmanship and the cultural histories embedded in these objects. To expand my knowledge and connect with others who share this niche passion, I became a member of the <a style={{color:"inherit"}} href="https://fancircleinternational.org/">Fan Circle International</a>.
                                </p>
                            <p className="centrep">
                                This site is dedicated entirely to the conservation of fans and featherwork — a space where I share specialist treatments, ongoing projects, and insights into the craftmanship and care of these remarkable objects.
                                </p>
                            <p className="centrep">
                                If you’d like to explore my broader work as a freelance conservator, you can visit me at <a style={{color:"inherit"}} href="https://phoenix-conservation.co.uk">Phoenix Object Conservation</a>.
                                </p>
                        </div>
                        <div id={about.getintouch}>
                            <p>
                                <Link to="/contact" style={{ textDecoration: 'none', color: 'inherit' }}>Get in Touch</Link>
                            </p>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default About;